import React, { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';

/**
 * DarkModeToggle - Theme switcher component
 * Persists preference to localStorage and applies CSS variables
 */
const DarkModeToggle = () => {
  const [isDark, setIsDark] = useState(() => {
    // Check localStorage or system preference
    const saved = localStorage.getItem('darkMode');
    if (saved !== null) {
      return saved === 'true';
    }
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    // Apply theme to document
    if (isDark) {
      document.documentElement.classList.add('dark-mode');
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark-mode');
      document.documentElement.setAttribute('data-theme', 'light');
    }
    
    // Save preference
    localStorage.setItem('darkMode', isDark.toString());
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(prev => !prev);
  };

  return (
    <button
      className="dark-mode-toggle"
      onClick={toggleTheme}
      aria-label={isDark ? 'Activar modo claro' : 'Activar modo oscuro'}
      title={isDark ? 'Modo claro' : 'Modo oscuro'}
    >
      <div className="dark-mode-toggle-track">
        <div className="dark-mode-toggle-thumb">
          {isDark ? (
            <Moon size={14} className="dark-mode-icon" />
          ) : (
            <Sun size={14} className="dark-mode-icon" />
          )}
        </div>
      </div>
    </button>
  );
};

export default DarkModeToggle;
